'use client'

import { createTRPCReact } from '@trpc/react-query'

import type { AppRouter } from '@rewardops/api'

export const trpc = createTRPCReact<AppRouter>()
